/**
 * API configuration and endpoints
 */

export const BASE_URL = 
  window.location.hostname === 'localhost' 
    ? "http://localhost:8000" 
    : "https://dlqw5ngx5xpnk.cloudfront.net";

export const API_ENDPOINTS = {
  APPLICATION: {
    SAVE: "/api/application/save",
    SUBMIT: (id) => `/api/application/${id}/submit`,
    GET: (id) => `/api/application/${id}`,
    CREATE: "/api/application/create",
    DRAFT: "/api/application/draft",
  },
  AUTH: {
    LOGIN: "/api/auth/login",
    SIGNUP: "/api/auth/signup",
    LOGOUT: "/api/auth/logout",
    VERIFY_EMAIL: "/api/auth/verify-email",
    FORGOT_PASSWORD: "/api/auth/forgot-password",
    RESET_PASSWORD: "/api/auth/reset-password",
  },
  USER: {
    PROFILE: "/api/user/profile",
    UPDATE: "/api/user/update",
  },
  EDUCATION: {
    SAVE: "/api/education",
    GET: (appId) => `/api/education/${appId}`,
  },
  EXPERIENCE: {
    SAVE: "/api/experience",
    GET: (appId) => `/api/experience/${appId}`,
  },
  REFEREE: {
    SAVE: "/api/referee",
    GET: (appId) => `/api/referee/${appId}`,
  },
  PARSE_RESUME: "/api/parseresume",
};

export const API_TIMEOUT = 30000; // 30 seconds

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};
